export const errorTypes = {
  required: 'required',
  maxlength: 'maxlength',
  minLength: 'minLength',
  email: 'email'
}
